import { resolveDescriptor, resolveMinMax, resolveMinMaxDescription } from '../../../../../../util/searchParamNameUtils';

export const resolveSearchParameters = ({
  params: {
    id,
    minId,
    maxId,
    minYear,
    maxYear,
    authorStart,
    authorInclude,
    authorMatch,
    authorNot,
    publicationType,
    eventStart,
    eventInclude,
    eventMatch,
    eventNot,
    minGeologicAgeId,
    maxGeologicAgeId,
    bodyOfWater,
    country,
    locStart,
    locInclude,
    locMatch,
    locNot,
    minLatitude,
    maxLatitude,
    minLongitude,
    maxLongitude,
  },
  geologicAges,
  publicationTypes,
}) => {
  const messages = [];

  if (id != null) {
    messages.push(`ID = ${id}`);
  }

  resolveMinMax('ID', minId, maxId, messages);

  resolveMinMax('Year', minYear, maxYear, messages);

  if (authorStart != null) {
    messages.push(`Author starts with '${authorStart}'`);
  }

  if (authorMatch != null) {
    messages.push(`Author = '${authorMatch}'`);
  }

  if (authorInclude != null) {
    messages.push(`Author contains '${authorInclude}'`);
  }

  if (authorNot != null) {
    messages.push(`Author != '${authorNot}'`);
  }

  if (publicationType != null) {
    messages.push(`Publication = ${resolveDescriptor(publicationTypes, publicationType)}`);
  }

  if (eventStart != null) {
    messages.push(`Event starts with '${eventStart}'`);
  }

  if (eventMatch != null) {
    messages.push(`Event = '${eventMatch}'`);
  }

  if (eventInclude != null) {
    messages.push(`Event contains '${eventInclude}'`);
  }

  if (eventNot != null) {
    messages.push(`Event != '${eventNot}'`);
  }

  resolveMinMaxDescription('Geologic Age', minGeologicAgeId, maxGeologicAgeId, geologicAges, messages);

  if (bodyOfWater != null) {
    messages.push(`Body of Water = ${bodyOfWater}`);
  }

  if (country != null) {
    messages.push(`Country = ${country}`);
  }

  if (locStart != null) {
    messages.push(`Location starts with '${locStart}'`);
  }

  if (locMatch != null) {
    messages.push(`Location = '${locMatch}'`);
  }

  if (locInclude != null) {
    messages.push(`Location contains '${locInclude}'`);
  }

  if (locNot != null) {
    messages.push(`Location != '${locNot}'`);
  }

  resolveMinMax('Latitude', minLatitude, maxLatitude, messages);
  resolveMinMax('Longitude', minLongitude, maxLongitude, messages);

  return messages;
};
